import React from "react";
import ReactMarkdown from "react-markdown";

interface Props {
    text?: string;
    children?: React.ReactNode;
}

export const Prose = (props: Props) => {
    if (props.text != null) {
        return <ReactMarkdown className="legacy-page">{props.text}</ReactMarkdown>;
    } else {
        return <div className="legacy-page">{props.children}</div>;
    }
};
